import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'
import { StatusTone } from 'src/constants/partnerDriver/enums'
import { semanticColors } from 'src/constants/semanticTokens'

interface Props {
  tone: StatusTone
  text: string
  dataTestId?: string
}

// Same token pairs CustomerStatusChip uses: the text colour always matches its tint.
const toneStyles: Record<StatusTone, { background: any; text: any }> = {
  [StatusTone.Neutral]: { background: tw`bg-shades-100`, text: tw`text-shades-500` },
  [StatusTone.Info]: {
    background: { backgroundColor: semanticColors.feedback.infoBg },
    text: { color: semanticColors.feedback.infoFg },
  },
  [StatusTone.Warning]: {
    background: { backgroundColor: semanticColors.feedback.warningBg },
    text: { color: semanticColors.feedback.warningFg },
  },
  [StatusTone.Success]: {
    background: { backgroundColor: semanticColors.feedback.successBg },
    text: { color: semanticColors.feedback.successFg },
  },
  [StatusTone.Critical]: {
    background: { backgroundColor: semanticColors.feedback.errorBg },
    text: { color: semanticColors.feedback.errorFg },
  },
}

const StatusToneChipComponent = ({ tone, text, dataTestId }: Props) => {
  const styles = toneStyles[tone]

  return (
    <Chip
      text={text}
      className={styles.background}
      textClassName={styles.text}
      dataTestId={dataTestId}
    />
  )
}

export const StatusToneChip = memo(StatusToneChipComponent)
